function datePicker() {
    datePickerController.createDatePicker({
        formElements:{
            "input-date-1-jj--hidden":"%d",
            "input-date-1-mm--hidden":"%m",
            "input-date-1-aaaa--hidden":"%Y"
        },
        staticPos: true,
        fillGrid: true,
        noTodayButton: true,
        // Enable the selection of all dates rendered within the grid
        constrainSelection: false,
        // Remove the associated input from the U.I.
        hideInput: true,
        callbackFunctions: {
           // "datereturned": [showInternationalDate]
        }
    });
}

function frenchToEnglishDate(frenchDate) {
    var dateElem = frenchDate.split('-');
    return dateElem[1] + '/' + dateElem[2] + '/' + dateElem[0];
}

function showInternationalDate(argObj) {
    var argObjId = argObj.id || argObj.attr('id');
    var argObjDate = argObj.date || new Date(frenchToEnglishDate(argObj.val())),
        inputHidden = document.getElementById(argObjId + '-hidden');
    inputHidden.value = datePickerController.printFormattedDate(argObjDate, "%Y-%m-%d", false);
}

function submitAgenda() {
    var el = document.getElementsByTagName('td');
    const form = document.getElementById('agenda-form');
    for (var i = 0; i < el.length; i++) {
        el[i].addEventListener("keypress", function (e) {
            if (e.keyCode == 13) {
                e.preventDefault();
                form.dispatchEvent(createEvent('submit'));
                form.submit();
            }
        });
        el[i].addEventListener('click', function () {
            console.log("click");
            window.setTimeout(function() {
                form.dispatchEvent(createEvent('submit'));
                form.submit();
            }, 200);
        });
    }
}
